import { getDomainSource, SERVICE, type ServiceType } from '@musinsa/packages-device-detection';
import type { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { getCuratorApiBaseURL } from './getCuratorApiBaseURL';

const isMigratedAPI = (url: string) => {
  return url.startsWith('/v2') || url.includes('affiliate/v2');
};

export const setupServicePlatformInterceptor = (
  instance: AxiosInstance,
  xPlatform: ServiceType,
): void => {
  if (typeof window === 'undefined' || xPlatform === SERVICE.UNKNOWN) return;

  instance.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      if (config.url && isMigratedAPI(config.url)) {
        const service =
          typeof window !== 'undefined' ? getDomainSource(window.location.hostname) : xPlatform;
        config.baseURL = getCuratorApiBaseURL(service);
        config.headers['x-platform'] = service;
      }
      return config;
    },
    (error) => Promise.reject(error),
  );
};
